import curry from 'lodash/fp/curry';
import { MyOrderFragment } from '../generated/graphql';

export const isBookingType = curry(
    (type: string, order: MyOrderFragment['orderItems'][number]): boolean => order.__typename === type
);

export const bookingRequiresPayment = (order: MyOrderFragment): boolean =>
    !!order.paymentOptions && order.paymentOptions.totalAmountDue > 0;
